<ngx-spinner
  bdColor="rgb(255,255,255)"
  size="default"
  [fullScreen]="true"
  template="<img src='../assets/images/loading.gif' />"
>
  <p class="label-spinner mt-4" data-testid="loading-paw">Carregando...</p>
</ngx-spinner>
<router-outlet></router-outlet>
